import React, { useContext, useState } from "react"
import { LoadingContext } from "../M_Components"
import { useTranslation } from "react-i18next"
import { Card, CardContent, Typography, Avatar, Divider, Stack, } from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import './settings.css'
import { BadgeOutlined, BusinessOutlined, EmailOutlined, PhoneAndroidOutlined } from "@mui/icons-material"

export default function Profile() {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()

    const profile = JSON.parse(localStorage.getItem("profile") || "{}")
    const roles = JSON.parse(localStorage.getItem("roles") || "[]")


    return (
        <div className="divGlobalSettings">
            <div className="subTitleSettings">
                <div>
                    <div style={{ color: ctx.secondaryColor }} data-testid="change-password-title">
                        {t("Profile")}
                    </div>
                    <div className="labelSubtitleSettings" data-testid="change-password-info">
                        {t("InfoProfile")}
                    </div>
                </div>
            </div>

            <Card className="profileCard">
                <CardContent>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar sx={{ bgcolor: ctx.secondaryColor, width: 50, height: 50 }}>
                            <PersonIcon />
                        </Avatar>
                        <Typography variant="h6">{profile.UserName}</Typography>
                    </Stack>

                    <Divider sx={{ my: 2 }} />

                    <Stack spacing={2}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <EmailOutlined />
                            <Typography sx={{ textTransform: "none !important" }}>{profile.Email}</Typography>
                        </Stack>

                        <Stack direction="row" spacing={1} alignItems="center">
                            <BadgeOutlined />
                            <Typography>{roles.map(r => r.Name).join(", ")}</Typography>
                        </Stack>

                        <Stack direction="row" spacing={1} alignItems="center">
                            <BusinessOutlined />
                            <Typography>{localStorage.getItem("accountCompany")}</Typography>
                        </Stack>

                        <Stack direction="row" spacing={1} alignItems="center">
                            <PhoneAndroidOutlined />
                            <Typography>{profile.PhoneNumber || t("WithoutNumber")}</Typography>
                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        </div>
    )
}
